/* Copyright (c) 2023-2026, NVIDIA CORPORATION.  All rights reserved.
 *
 * NVIDIA CORPORATION and its licensors retain all intellectual property
 * and proprietary rights in and to this software, related documentation
 * and any modifications thereto.  Any use, reproduction, disclosure or
 * distribution of this software and related documentation without an express
 * license agreement from NVIDIA CORPORATION is strictly prohibited.
 */

import { coerceBooleanProperty } from '@angular/cdk/coercion';
import { Directive, Inject, Input, OnInit, Optional } from '@angular/core';
import { MatTooltip } from '@angular/material/tooltip';
import { NvHigConfig, NV_HIG_CONFIG } from '../hig.config';

/**
 * Disables tooltip on certain platforms as defined by NV HIG.
 * See [HIG Tooltips](https://sites.google.com/nvidia.com/humaninterfaceguideline/the-hig/components/tooltips)
 */
@Directive({
    selector: '[matTooltip][nvTooltipDisabled], [matTooltip]:not([matTooltipDisabled])[nvDisableTooltipIfNeeded]',
    standalone: true
})
export class NvDisableTooltipDirective implements OnInit {
    /**
     * An extension of MatTooltip#matTooltipDisabled conforming to NV HIG.
     */
    @Input('nvTooltipDisabled')
    get disabled(): boolean {
        return this.tooltip.disabled;
    }
    set disabled(newValue: boolean) {
        this.tooltip.disabled = coerceBooleanProperty(newValue) || this.shouldDisableTooltip;
    }

    private readonly shouldDisableTooltip: boolean = false;

    constructor(
        @Optional() @Inject(NV_HIG_CONFIG) config: NvHigConfig,
        private tooltip: MatTooltip
    ) {
        this.shouldDisableTooltip = !!config?.mobileMode || !!config?.tvMode;
    }

    ngOnInit(): void {
        if (this.shouldDisableTooltip) {
            this.tooltip.disabled = true;
        }
    }
}
